import { createAction, createReducer } from '@reduxjs/toolkit';
const fetchTopBannerSuccess = createAction('FETCH_TOP_BANNER_SUCCESS');
const fetchBottomBannerSuccess = createAction('FETCH_BOTTOM_BANNER_SUCCESS');
const fetchTopBannerIdFailed = createAction('FETCH_TOP_BANNER_ID_FAILED');
const fetchBottomBannerIdFailed = createAction('FETCH_BOTTOM_BANNER_ID_FAILED');
const baseState = {
    topBanner: null,
    bottomBanner: null,
};
const bannerReducer = createReducer(baseState, (builder) => {
    builder
        .addCase(fetchTopBannerSuccess, (state, action) => {
        state.topBanner = action.payload;
    })
        .addCase(fetchBottomBannerSuccess, (state, action) => {
        state.bottomBanner = action.payload;
    })
        .addCase(fetchTopBannerIdFailed, (state, _) => {
        state.topBanner = null;
    })
        .addCase(fetchBottomBannerIdFailed, (state, _) => {
        state.bottomBanner = null;
    });
});
export default bannerReducer;
